import React, { useState, useEffect } from 'react';

import store from '../../store';
import { useParams } from 'react-router-dom';

import { useGetRecord } from 'root/admin/components/hooks';
import { Title, Thumbnail } from 'root/admin/components';

import { Form, Field, Loader, Row, ManyToManySelect, Checkbox, DatePicker, Attachments } from '@smartplatform/ui';
import { Editor } from '../../components';
import ImagesNew from '../../components/images';

import './style.scss';

const fio = deputy => (deputy ? `${deputy.lastName} ${deputy.firstName} ${deputy.middleName}` : '');
const fioShort = deputy =>
	deputy ? `${deputy.lastName} ${deputy.firstName.substr(0, 1)}. ${deputy.middleName.substr(0, 1)}.` : '';

const ArticleEdit = ({ match, rootPath, type, tabName, path }) => {
	// const { id } = match.params;
	const { id } = useParams();
	const options = { include: ['tags', 'images'] };
	const record = useGetRecord({ model: 'Article', id, options, tabName });
	const [error, setError] = useState();
	const [mainSlide, setMainSlide] = useState();
	const [attachmentsInstance, setAttachmentIsnance] = useState();

	useEffect(() => {
		record && getMainSlideInfo();
	}, [record]);

	if (record && !record.id) {
		record.mainPage = false;
		record.publishAt = new Date();
	}

	if (!record) {
		return <Loader />;
	}

	const getMainSlideInfo = async () => {
		const onMainSlide = await store.model.MainSlide.find({
			where: {
				mainSlideId: id,
			},
		});
		if (onMainSlide) {
			setMainSlide(onMainSlide[0]);
		}
	};

	const setOnMainSlideSwitch = async () => {
		if (!mainSlide) {
			const newSlide = new store.model.MainSlide();
			await record.save();
			newSlide.article = record;
			await newSlide.save();
			newSlide.order = newSlide.id;
			newSlide.save();
			setMainSlide(newSlide);
		} else {
			mainSlide.delete();
			setMainSlide();
		}
	};

	const beforeSave = record => {
		record.type = type.id;
	};

	const onSave = async () => {
		if (isNaN(id) && type.id === 'news') {
			store.history.push(`${path}/${record.id}`);
			store.ui.setNotification({ message: 'Запись создана' });
		} else {
			store.ui.setNotification({ message: 'Запись сохранена' });
			store.history.push(path);
		}

		return true;
	};

	const onDelete = async () => {
		try {
			store.history.push(path);
		} catch (err) {
			console.log('record already deleted');
		}
	};

	const onEditorChange = (content, editor) => {
		record.contentTop = content;
	};

	console.log(record);

	const onUploadStart = files => {};

	const onUploadEnd = files => {
		console.log('onFilesUpload', files);

		if (attachmentsInstance) attachmentsInstance.reload();
	};

	const tagsInq = type.id === 'news' ? ['article', 'all'] : ['all'];
	return (
		<div>
			<Title record={record} name={type.label} />
			<Form record={record} rootPath={rootPath} onSave={onSave} stay onDelete={onDelete} beforeSave={beforeSave}>
				<Field property="name" label="Название" />
				<Field property="newsOfDay" label="Новость дня" />
				{type.id === 'news' && (
					<>
						<div className="article__edit-content">
							<h5>Содержание</h5>

							<Editor
								value={record.contentTop}
								onChange={onEditorChange}
								mediaModel={store.model.Image}
								height={600}
								filesUploadData={{
									record: record,
									relation: 'attachments',
									property: 'filename',
									// accept: '.jpg, .svg',
									onStart: onUploadStart,
									onEnd: onUploadEnd,
								}}
							/>
						</div>
						{record.id && (
							<Attachments
								record={record}
								relation="attachments"
								store={store.model}
								instance={instance => setAttachmentIsnance(instance)}
							/>
						)}
						{record.id && (
							<div className="form-field">
								<label>Фотогалерея (слайдер)</label>
								<ImagesNew
									record={record}
									relation="images"
									model={store.model.Attachment}
									property="filename"
									textProperty="name"
									disableUpload={record.imported}
									getUrl={image =>
										record.imported
											? '/api/containers/articles/download/' + image.filename
											: image.downloadFile('filename')
									}
								/>
							</div>
						)}


					</>
				)}
				{type.id !== 'news' && (
					<>
						<Field property="subheader" label="Подзаголовок">
							<Editor />
						</Field>
						<Field property="contentTop" label="Содержание">
							<Editor />
						</Field>
					</>
				)}
				<Field label="Метки">
					<ManyToManySelect
						relation="tags"
						computed={type => <span title={type.id}>{type.name}</span>}
						itemTag={type => <span title={type.id}>{type.name}</span>}
						searchFields={['name']}
						filter={{ where: { type: { inq: tagsInq } } }}
					/>
				</Field>
				<Row>
					<Field property="publishAt" label="Дата и время публикации">
						<DatePicker showTimeSelect timeIntervals={15} />
					</Field>
					<Field property="removeAt" label="Дата и время снятия с публикации">
						<DatePicker showTimeSelect timeIntervals={15} />
					</Field>
					<div />
				</Row>
				<Row>
					<Field property="publish" label="Опубликовать" />
					<Field property="mainPage" label="Размещать на главной" />
					<div />
				</Row>

				<Row className="form-field">
					<Checkbox checked={!!mainSlide} onChange={setOnMainSlideSwitch} label="Размещать на главном слайдере" />
				</Row>

				<Thumbnail record={record} label="Обложка публикации" />

				<Row>
					<Field label="Депутаты, связанные с новостью">
						<ManyToManySelect
							relation="deputies"
							computed={fio}
							itemTag={fioShort}
							searchFields={[{ name: 'lastName', start: true }]}
						/>
					</Field>
					<Field label="Фракции, связанные с новостью">
						<ManyToManySelect
							relation="fractions"
							property="shortName"
							itemTag={f => f.shortName}
							filter={{ where: { existing: true } }}
							noSearch={true}
						/>
					</Field>
					<Field label="Комитеты, связанные с новостью">
						<ManyToManySelect relation="committees" property="name" itemTag={f => f.name} filter={{ where: { deactivated: { neq: true } } }} noSearch={true} />
					</Field>
				</Row>

				{error && <div className="form__error">{error}</div>}
			</Form>
		</div>
	);
};
export default ArticleEdit;
